<script setup>
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
    <g clip-path="url(#clip0_288_3477)">
      <path d="M20 0.5C30.7696 0.5 39.5 9.23045 39.5 20C39.5 30.7696 30.7696 39.5 20 39.5C9.23045 39.5 0.5 30.7696 0.5 20C0.5 9.23045 9.23045 0.5 20 0.5Z" fill="#F9F9F9" stroke="#E9E9E9"/>
      <path d="M18.8906 11.7393C19.5624 11.2914 20.4376 11.2914 21.1094 11.7393L28.1094 16.4062C28.6657 16.7772 29 17.4017 29 18.0703V26C28.9998 27.1044 28.1044 28 27 28H22V22.4004C22 21.6272 21.5523 21 21 21H19C18.4477 21 18 21.6272 18 22.4004V28H13C11.8956 28 11.0002 27.1044 11 26V18.0703C11 17.4017 11.3343 16.7772 11.8906 16.4062L18.8906 11.7393Z" fill="black"/>
    </g>
    <defs>
      <clipPath id="clip0_288_3477">
        <rect width="40" height="40" fill="white"/>
      </clipPath>
    </defs>
  </svg>
</template>


